import * as React from 'react';
import { useSelector } from 'react-redux';

import { CheckDealSection } from '../../components/CheckDealSection';
import { selectDealFormUrl } from '../../selectors/promoInfo/selectDealFormUrl';
import { trackNavigateToDealForm } from '../../utils/analytics';

export const CheckDealSectionContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const dealFormUrl = useSelector(selectDealFormUrl);

  const onNavigateToDealFormClick = () => {
    trackNavigateToDealForm('basement');
  };

  return <CheckDealSection dealFormUrl={dealFormUrl} onNavigateToDealFormClick={onNavigateToDealFormClick} />;
};
